import React, { useContext, useState, useEffect, useRef } from "react";
import { Tabs, Tab, Form, Dropdown, Button, Row, Col } from "react-bootstrap";
import "react-datepicker/dist/react-datepicker.css";
import "react-toastify/dist/ReactToastify.css";
import Select from "react-select";
import swal from "sweetalert";
import {
  BASE_URL_API_TRANXT,
  BASE_URL_API_TRANXT_API,
  BASE_URL_APISERVICES,
} from "../../utils/Constants";
import { GlobalContext } from "../../Context/GlobalState";
import { useHistory } from "react-router";
import { adminAuth } from "../../config";
import { generateHashKey2 } from "../../utils/utilFuctions";
import * as XLSX from "xlsx";
import { getBankStatementData } from "./bankStatementFormats";
import { API_ENDPOINTS } from "../../utils/apiEndpoints";
const userTypes = [
  { label: "Master Distributor", value: "4" },
  { label: "Distributor", value: "3" },
  { label: "Retailer", value: "2" },
  { label: "API Partner", value: "5" },
];
const tariff = [{ label: "Bumppy", value: "3" }];

const AccountStatementUpload = () => {
  const initialState = {
    Bank: "",
    AccountNO: "",
    ifscCode: "",
    excelData: [],
  };
  const { username1, password1 } = adminAuth;
  const [state, setState] = useState(initialState);
  const [userRoles, setUserRoles] = useState([]);
  const [parentList, setParentList] = useState([]);
  const [banks, setBanks] = useState([]);
  const [selectedBank, setSelectedBank] = useState(null);
  const { user, setTransactionLoaderState } = useContext(GlobalContext);

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    const reader = new FileReader();

    console.log("log 1");

    reader.onload = (evt) => {
      const bstr = evt.target.result;
      const wb = XLSX.read(bstr, { type: "binary" });
      console.log("log 2");
      console.log(wb.SheetNames[0]);

      const wsname = wb.SheetNames[0];

      const ws = wb.Sheets[wsname];

      const jsonData = XLSX.utils.sheet_to_json(ws, { defval: "" });

      var exelDataRead = getBankStatementData(selectedBank.bankName, jsonData);

      setState((prev) => ({
        ...prev,
        uploadedFile: file,
        excelData: exelDataRead,
      }));

      console.log("Parsed Excel JSON:", jsonData);
    };

    reader.readAsBinaryString(file);
  };

  const validateForm = () => {
    if (
      state.AccountNO === "" ||
      //   state.Bank == ""||
      //   state.excelData == "" ||
      state.ifscCode === ""
    ) {
      swal("Invalid", "Please Fill Mandatory Fields", "error");
      return;
    }
    uploadAccountStatementData();
  };

  const clearForm = () => {
    setState(initialState);
  };

  const uploadAccountStatementData = async () => {
    try {
      setTransactionLoaderState(true);
      const myHeaders = new Headers();
      myHeaders.append(
        "Authorization",
        "Basic " + Buffer.from(username1 + ":" + password1).toString("base64")
        );

      var raw = JSON.stringify({
        accountNo: state.AccountNO,
        ifscCode: state.ifscCode,
        bankName: selectedBank.bankName,
        statementData: state.excelData,
      });

      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      const res = await fetch(
        `${BASE_URL_APISERVICES}${API_ENDPOINTS.UPLOAD_ACC_STATEMENT}`,
        requestOptions
      );

      const data = await res.json();
      if (data.responseCode == "00") {
        swal("Document Upload Successfully", data.responseMessage, "success");
        clearForm();
      } else {
        swal(" Failed", data.responseMessage, "error");
      }
      setTransactionLoaderState(false);
    } catch (error) {
      setTransactionLoaderState(false);
      console.log("error", error);
      swal("Failed", "Error From Server", "error");
    }
  };

  const getLoadRequestBanks = async () => {
    try {
      const raw = "";
      const hash_key = await generateHashKey2(user.ReferId);
      var myHeaders = new Headers();
      myHeaders.append("HASH_KEY", hash_key);
      myHeaders.append("Content-Type", "application/json");
      var requestOptions = {
        method: "GET",
        headers: myHeaders,
        redirect: "follow",
      };

      const res = await fetch(
        `${BASE_URL_APISERVICES}${API_ENDPOINTS.GET_LOAD_REQ_BANK}`,
        requestOptions
      );
      const raw2 = await res.text();
      const data = JSON.parse(raw2);
      console.log(data);
      setBanks(
        data.map((bank) => {
          return {
            ...bank,
            value: `${bank.bankName} `,
            label: `${bank.bankName}`,
          };
        })
      );
    } catch (error) {
      console.log("error", error);
    }
  };

  useEffect(() => {
    getLoadRequestBanks();
  }, []);

  return (
    <div style={{ padding: "1rem" }} className="bg-light">
      <div
        style={{ borderRadius: "8px" }}
        className="card m-0 p-0 mt-4 mr-2 ml-2"
      >
        <div className="card-body m-0 p-1 px-2">
          <div>
            <div
              className="p-2 pl-1"
              style={{
                fontFamily: "Poppins",
                fontSize: "32px",
                fontWeight: "600",
                lineHeight: "48px",
                letterSpacing: "0em",
                textAlign: "left",
                padding: "0px",
                background: "#FFFFFF",
                color: "#4267B2",
                fontWeight: "bolder",
                fontfamily: "Poppins !impotent",
                fontSize: "28px",
              }}
            >
              Upload Bank Account Statement
            </div>
            <div>
              <div className="row col-12 justify-content-start m-0 pl-10 py-0 pb-1">
                <div className="col-5 pr-3 m-0 p-0">
                  <Form.Group>
                    <Form.Label className="text-dark">
                      <span style={{ color: "red" }}>*</span>
                      {`Select Bank`}
                    </Form.Label>
                       <Select
                      options={banks}
                      onChange={(e) => {
                        setSelectedBank(e);
                        setState({ ...state, 
                          AccountNO: e.accountNo || "" ,
                          ifscCode: e.ifscCode || "",});
                      }}
                      value={selectedBank}
                    />
                  </Form.Group>
                </div>
                <div className="col-5 p-0 m-0 pr-3">
                  <Form.Group>
                    <Form.Label className="text-dark">
                      <span style={{ color: "red" }}>*</span>
                      {`Account NO`}
                    </Form.Label>
                    <Form.Control
                      type="text"
                      className="form-control rounded-lg"
                      placeholder="Enter Account No"
                      value={state.AccountNO}
                      onChange={(e) => {
                        setState({ ...state, AccountNO: e.target.value });
                      }}
                      style={{ borderRadius: "0px" }}
                      readOnly
                    />
                  </Form.Group>
                </div>
              </div>
              <div className="row col-12 pl-10 py-0 m-0 pb-3">
                <div className="col-5 p-0 m-0 pr-3">
                  <Form.Group>
                    <Form.Label className="text-dark">
                      <span style={{ color: "red" }}>*</span>
                      {`IFSC Code`}
                    </Form.Label>
                    <Form.Control
                      type="text"
                      className="form-control rounded-lg"
                      placeholder="Enter IFSC Code"
                      value={state.ifscCode}
                      onChange={(e) => {
                        setState({ ...state, ifscCode: e.target.value });
                      }}
                      style={{ borderRadius: "0px" }}
                      readOnly
                    />
                  </Form.Group>
                </div>
                <div className="col-5 m-0 p-0 pr-3">
                  <Form.Group>
                    <Form.Label className="text-dark">
                      <span style={{ color: "red" }}>*</span>
                      Upload Excel
                    </Form.Label>
                    <Form.Control
                      type="file"
                      accept=".xlsx, .xls"
                      onChange={handleFileChange}
                      className="form-control rounded-lg"
                    />
                    {state.uploadedFile && (
                      <div className="mt-2 text-muted">
                        <small>
                          <strong>Selected File:</strong>{" "}
                          {state.uploadedFile.name}
                        </small>
                      </div>
                    )}
                  </Form.Group>
                </div>
              </div>
              <div className="row col-12 pl-10 py-0 m-0 pb-3">
                <div className="col-2 p-0  pr-3">
                  <Button
                    className="rounded-10 btn-block"
                    variant="primary"
                    onClick={validateForm}
                  >
                    Submit
                  </Button>
                </div>
                <div className="col-2 p-0 m-0 pr-3">
                  <Button
                    className="rounded-10 btn-block border border-primary"
                    variant="white"
                    onClick={clearForm}
                  >
                    Clear
                  </Button>
                </div>
                <div className="col p-0"></div>
                <div className="col p-0"></div>
                <div className="col-5 m-0 p-0 pr-3"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default AccountStatementUpload;
